<template>
  <div
    class="san-button  "
    style="color: #de1e23;"
    :style="{ marginRight: marginRight + 'px' }"
    @click="clickHandle"
  >
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "santakButton",
  props: {
    title: {
      type: String,
      required: true,
    },
    marginRight: {
      type: String | Number,
      default: 20,
    },
    isActive: {
      type: String | Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    clickHandle() {
      this.$emit("clickHandle");
    },
  },
};
</script>

<style scoped lang="less" scoped>
.san-button {
  display: inline-block;
  cursor: pointer;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  border: 1px solid #dedede;
  color: #000 !important;
  background-color: #fff;
}
.san-button:hover{

  border: 1px solid #006EC7;
}
</style>
